export default __webpack_public_path__ + "static/media/direpay.4ef038a0.svg";